import React from "react";
import useDialogLauncher from "@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher";
import {DialogManager} from "@/dialogs_new/DialogManager";
import {useTranslation} from "react-i18next";

export default function EvaluationListItem({evaluation}) {
  const launch = useDialogLauncher();
  const {t} = useTranslation();

  function onClick(e) {
    if (evaluation.kind === "evaluation-project-partner") launch(DialogManager.EvaluationProjectPartner.Config(evaluation.id));
    if (evaluation.kind === "evaluation-project-educator") launch(DialogManager.EvaluationProjectEducator.Config(evaluation.id));
    if (evaluation.kind === "evaluation-event-partner") launch(DialogManager.EvaluationEventPartner.Config(evaluation.id));
    if (evaluation.kind === "evaluation-event-educator") launch(DialogManager.EvaluationEventEducator.Config(evaluation.id));
    console.error("Unknown evaluation kind: " + evaluation.kind);
  }

  const updatedDate = evaluation.updatedAt
    ? String(evaluation.updatedAt).slice(0, 10)
    : null;

  return (
    <li className="flex items-start justify-between gap-4">
      <div className="min-w-0 w-full">
        <button
          onClick={onClick}
          className="hover:underline cursor-pointer text-left w-full"
          title={evaluation.name}
        >
          <div className="truncate">{evaluation.name}</div>
        </button>
      </div>
    </li>
  );
}
